import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { relations } from 'drizzle-orm';
import { jsonb, pgEnum, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { whatsappConversations } from './whatsapp-conversations';

export const whatsappMessageDirectionEnum = pgEnum('whatsapp_message_direction', [
  'in',
  'out',
]);

export const whatsappMessageStatusEnum = pgEnum('whatsapp_message_status', [
  'sent',
  'failed',
]);

export const whatsappMessages = pgTable('whatsapp_messages', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  conversationId: uuid('conversation_id')
    .references(() => whatsappConversations.id)
    .notNull(),
  direction: whatsappMessageDirectionEnum('direction').notNull(),
  content: text('content'),
  status: whatsappMessageStatusEnum('status').notNull().default('sent'),
  errorMessage: text('error_message'),
  rawPayload: jsonb('raw_payload'),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
});

export const whatsappMessagesRelations = relations(whatsappMessages, ({ one }) => ({
  conversation: one(whatsappConversations, {
    fields: [whatsappMessages.conversationId],
    references: [whatsappConversations.id],
  }),
}));

export type WhatsappMessage = InferSelectModel<typeof whatsappMessages>;
export type CreateWhatsappMessageInput = InferInsertModel<typeof whatsappMessages>;
